import React from 'react';
import AccordianList from 'sub_components/Billing/AccordianList';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;
const EditIconHover = `${CDN_URL}common/icons-edit-selected-lg.svg`;

const AtlantaSelected = `${CDN_URL}support/ticketing/location-atlanta-selected-lg.svg`;
const BirminghamSelected = `${CDN_URL}support/ticketing/location-birmingham-selected-lg.svg`;
const ChattanoogaSelected = `${CDN_URL}support/ticketing/location-chattanooga-selected-lg.svg`;
const HuntsvilleSelected = `${CDN_URL}support/ticketing/location-huntsville-selected-lg.svg`;
const NetworkSelected = `${CDN_URL}support/ticketing/icon-network-selected-lg.svg`;
const ColoSelected = `${CDN_URL}support/ticketing/icon-colo-selected-lg.svg`;
const StorageSelected = `${CDN_URL}support/ticketing/icon-storage-selected-lg.svg`;
const PortalSelected = `${CDN_URL}support/ticketing/icon-portal-selected-lg.svg`;
const questionSelected = `${CDN_URL}support/ticketing/invoice-general-selected-lg.png`;

function getIcon(selected) {
	switch (selected) {
		case 'atlanta':
			return AtlantaSelected;
		case 'birmingham':
			return BirminghamSelected;
		case 'chattanooga':
			return ChattanoogaSelected;
		case 'huntsville':
			return HuntsvilleSelected;
		case 'Colocation':
			return ColoSelected;
		case 'Network Services':
			return NetworkSelected;
		case 'Storage':
			return StorageSelected;
		case 'Portal':
			return PortalSelected;
		default:
			return StorageSelected;
	}
}

const EditDetails = ({ data, title, edit }) => {
	const selected = title === 'location' ? data.location : data.product;

	const selectedInvoice = data.billing && data.billing[0] !== 'general' ? data.billing : null;
	return (
		<div
			className={title !== 'ISSUE Type' ? 'edit-details-wrapper' : 'edit-details-wrapper billing'}
		>
			<div className='edit-details-header'>
				<div className='title heading70'>{title}</div>
				<div
					className='image'
					onClick={() => {
						edit(title === 'ISSUE Type' ? 'billing' : title);
					}}
				>
					<img
						src={EditIconDefault}
						onMouseOver={e => {
							e.currentTarget.src = EditIconHover;
						}}
						onMouseOut={e => {
							e.currentTarget.src = EditIconDefault;
						}}
					/>
				</div>
			</div>
			{title !== 'ISSUE Type' && (
				<div className='edit-details-selected'>
					<div className={`selected-image ${title}`}>
						<img src={getIcon(selected)} />
					</div>
					<div className='selected-title buttons10'>
						{selected === 'portal selected' ? 'select location' : selected}
					</div>
				</div>
			)}
			{title === 'ISSUE Type' && (
				<div className='edit-details-selected'>
					{selectedInvoice && (
						<AccordianList
							data={selectedInvoice}
							disableDropDown={true}
							lowerFilterAnchor='current-invoices-page'
							customOnClick={() => {}}
							enableNav
							selected={selectedInvoice[0].invoice_number}
							customIcons={true}
						/>
					)}
					{!selectedInvoice && (
						<div
							id='general-issue'
							className={data.billing[0] === 'general' ? 'general-issue selected' : 'general-issue'}
						>
							<div className='icon-section'>
								<img src={questionSelected} id='general' />
							</div>
							<div className='details-section'>
								<div className='title body20'>I have a general billing question.</div>
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default EditDetails;
